const logs = {
    page_title: 'سجلات التدقيق',
    title: 'سجلات التدقيق',
    subtitle: 'عرض بيانات السجل لأحداث المصادقة التي قام بها مستخدموك',
    event: 'حدث',
    user: 'مستخدم',
    application: 'تطبيق',
    time: 'الوقت',
    filter_by: 'تصفية حسب',
    last_1_hour: 'آخر ساعة',
    last_24_hours: 'آخر 24 ساعة',
    last_7_days: 'آخر 7 أيام',
    last_30_days: 'آخر 30 يومًا',
    custom_range: 'نطاق مخصص',
    from: 'من',
    to: 'إلى',
};
export default Object.freeze(logs);
